import useSWR from "swr";
import { FileListParams } from "@/types";
import { listFiles, getFile } from "@/services/storageManager";
import { API_ROUTES } from "@/utils/constants";

export function useFiles(params: FileListParams = {}) {
  const key =
    params.folderId !== undefined
      ? `${API_ROUTES.files}?folderId=${params.folderId || ""}&search=${params.search || ""}&sort=${params.sort || ""}&order=${params.order || ""}`
      : null;

  const { data, error, isLoading, mutate } = useSWR(
    key,
    () => listFiles(params),
    {
      revalidateOnFocus: false,
      dedupingInterval: 5000,
    }
  );

  return {
    files: data?.data || [],
    total: data?.total || 0,
    continuationToken: data?.continuationToken,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useFile(fileId: string | null) {
  const { data, error, isLoading, mutate } = useSWR(
    fileId ? API_ROUTES.file(fileId) : null,
    () => getFile(fileId!),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    file: data,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useStarredFiles() {
  const { data, error, isLoading, mutate } = useSWR(
    `${API_ROUTES.files}?starred=true`,
    () =>
      listFiles({
        starred: true,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    files: data?.data || [],
    total: data?.total || 0,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useRecentFiles(limit: number = 20) {
  const { data, error, isLoading, mutate } = useSWR(
    `${API_ROUTES.files}?recent=true&limit=${limit}`,
    () =>
      listFiles({
        sort: "date",
        order: "desc",
        limit,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    files: data?.data || [],
    total: data?.total || 0,
    isLoading,
    isError: error,
    mutate,
  };
}
